import React from 'react'
import PropTypes from 'prop-types'
import { Snackbar, Alert } from '@mui/material'

export default function Toast({
  open,
  onClose,
  message,
  severity = 'success',
  autoHideDuration = 4000,
  action = null,
  anchorOrigin = { vertical: 'top', horizontal: 'right' }
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      anchorOrigin={anchorOrigin}
      onClose={(event, reason) => {
        if (reason === 'clickaway') return
        onClose && onClose(event, reason)
      }}
    >
      <Alert
        onClose={(event, reason) => {
          if (reason === 'clickaway') return
          onClose && onClose(event, reason)
        }}
        severity={severity}
        variant="filled"
        sx={{ width: '100%', color: '#fff' }}
        action={action}
      >
        {message}
      </Alert>
    </Snackbar>
  )
}

Toast.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
  autoHideDuration: PropTypes.number,
  action: PropTypes.node,
  anchorOrigin: PropTypes.object
}
